import * as React from "react";
import {useCarousel} from "../../hooks/useCarousel";
import "./style.scss";
import Arrow from "./Arrow";
import Dots from "./Dots";

function makeIndices(start, delta, num) {
  const indices = [];
  while (indices.length < num) {
    indices.push(start);
    start += delta;
  }
  return indices;
}

export const CarouselContainer = ({
  children,
  slidesPresented = 1,
  interval = 0,
}) => {
  const slides = React.Children.toArray(children);
  const length = slides.length;
  const numActive = Math.min(length, slidesPresented);
  const [active, setActive, setNext, setPrev, handlers, style] = useCarousel(
    length,
    interval,
    {
      slidesPresented: numActive,
    }
  );
  const beforeIndices = makeIndices(slides.length - 1, -1, numActive);
  const afterIndices = makeIndices(0, +1, numActive);

  return (
    length > 0 && (
      <div className="carousel">
        {length > 1 ? (
          <div>
            <div className="carouselContent" {...handlers} style={style}>
              {beforeIndices.map((i) => (
                <CarouselChild key={i}>{slides[i]}</CarouselChild>
              ))}
              {slides.map((slide, index) => (
                <CarouselChild key={index}>{slide}</CarouselChild>
              ))}
              {afterIndices.map((i) => (
                <CarouselChild key={i}>{slides[i]}</CarouselChild>
              ))}
            </div>
            <div>
              <Arrow
                direction="left"
                handleClick={setPrev}
                slidesLength={length}
              />
              <Arrow
                direction="right"
                handleClick={setNext}
                slidesLength={length}
              />
              <Dots
                slides={slides}
                activeSlide={active}
                setActive={setActive}
              />
            </div>
          </div>
        ) : (
          <CarouselChild key={0}>{slides[0]}</CarouselChild>
        )}
      </div>
    )
  );
};

export const CarouselChild = ({children}) => (
  <div className="carouselItem">{children}</div>
);
